import { Component, Input, EventEmitter } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { EditorContentService } from '../services/editorcontent.service';
import { LoginService } from '../services/login.service';
import { DebuggerService } from 'app/services/debugger.service';
import { MultipleChoiceOption, Task, TaskType } from 'app/lib/Task';
import { Exam } from 'app/lib/Exam';
import { ExamService } from 'app/services/exam.service';

declare var require: (...any) => any;
declare var swal: any;
const sha256 = require("sha256");

@Component({
  selector: 'editor-component',
  templateUrl: './editor.component.html'
})

export class EditorComponent {

  @Input("resizeEmitter") resizeEmitter: EventEmitter<void>;

  private editorValue: any;
  private editor: any;
  private exam: Exam = null;
  private selectedTask: Task = null;

  private mcOptionsArray: MultipleChoiceOption[] = null;
  private loaded: boolean;
  private editorTextChangedProgrammatically: boolean = false;

  constructor(private languageService: LanguageService,
    private editorContentService: EditorContentService,
    private examService: ExamService,
    private loginService: LoginService,
    private debuggerService: DebuggerService) { }

  ngOnInit() {
    // load editor
    this.editor = (<any>window).ace.edit('editor');
    this.editor.setTheme('ace/theme/kr_theme');
    this.editor.getSession().setMode('ace/mode/python');
    this.editor.setOption('tabSize', 2);
    this.editor.session.setUseWrapMode(true);
    this.editor.session.setOption("indentedSoftWrap", false);
    this.editor.commands.bindKeys({ "Ctrl-L": null, "Ctrl-F": null });
    this.editor.on("change", () => {
      this.onEditorChange();
    }).bind(this);

    //TODO: test if onChange works. Requirement: somehow must be informed of changes in editor

    // register on focus for editor
    this.editor.on('focus', function () {
      this.editorContentService.onEditorFocus = true;
    }.bind(this), false);

    // register on blur for editor
    this.editor.on('blur', function () {
      this.editorContentService.onEditorFocus = false;
    }.bind(this), false);

    //prepare Tabs
    this.editorContentService.textInDisplayNeedsChangeEmitter.subscribe(
      () => this.onEditorContentEvent()
    );
    this.editorContentService.editorEnabler.subscribe(
      (condition) => {
        if (condition) {
          this.enableEditor();
        } else {
          this.disableEditor();
        }
      }
    );
    this.debuggerService.setInitialSessionMarkers(this.editor.session);
    this.debuggerService.setEditor(this.editor);
    this.resizeEmitter.subscribe(
      () => this.editor.resize()
    );
    this.loaded = true;
  }

  onEditorContentEvent() {
    //TODO: maybe have to remove listener for this event?
    this.setEditorValue(this.editorContentService.getCurrentEditorText());
  }

  public onEditorChange(): void {
    if (!this.editorTextChangedProgrammatically) {
      this.editorContentService.setTextOfCurrentEditorFromDisplay(this.getEditorValue());
    }

  }

  private getEditorValue(): string {
    return this.editor.getValue();
  }

  private setEditorValue(val: string) {
    //TODO: what is the purpose of the second argument?
    this.editor.setValue(val, 1);
  }

  public onSelect(tab: number) {
    //TODO: implement. 
  }

  disableEditor() {
    //diable editor: text cannot be changed and opacity is slightly see-through
    this.editor.setOptions({
      readOnly: true,
      highlightActiveLine: false,
      highlightGutterLine: false
    });
    this.editor.container.style.opacity = 0.75
  }

  enableEditor() {
    //enable editor: text can be changed and it is not see-through any longer
    this.editor.setOptions({
      readOnly: false,
      highlightActiveLine: true,
      highlightGutterLine: true
    });
    this.editor.container.style.opacity = 1;
  }


  


}



// WEBPACK FOOTER //
// ./src/app/components/editor.component.ts